import React, { Component } from 'react';

import { withTranslation } from 'react-i18next'
import CollapseIcon from '../../../images/collapse copy 6.png'
import ExpandIcon from '../../../images/expand copy 6.png'

class KonsesjonsforholdPersonMedAndel extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleInvolvert = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var personMedAndel = this.props.personMedAndel
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleInvolvert}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{personMedAndel.navn}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('navn')}</div>
                            <div className="value">{personMedAndel.navn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('andel')}</div>
                            <div className="value">{personMedAndel.teller}/{personMedAndel.nevner}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('adresse')}</div>
                            <div className="value">{personMedAndel.postadresselinje2 || personMedAndel.postadresselinje1}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('poststed')}</div>
                            <div className="value">{personMedAndel.postadresselinje3}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(KonsesjonsforholdPersonMedAndel)